import { render } from "./Authenticated.vue?vue&type=template&id=08e17982&bindings={\"app\":\"props\",\"fetchPageList\":\"options\"}"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script